define(["views/common/chartjs_utils"], function (chartUtils) {
    const barChartDatasetOptions = {
        borderColor: "transparent",
        backgroundColor: chartUtils.getBarGradient,
        maxBarThickness: 20,
        barPercentage: 1,
        borderRadius: (data) => (+data.raw >= 0 ? { topRight: 3, topLeft: 3 } : { bottomRight: 3, bottomLeft: 3 }),
        borderSkipped: false,
    };
    const barChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        stacked: false,
        interaction: { mode: "index", axis: "x", intersect: false },
        layout: {
            padding: {
                left: 40,
                right: 60,
                top: 30,
                bottom: 0,
            }
        },
        scales: {
            y: {
                display: true,
                position: "left",
                border: {
                    display: false,
                },
                ticks: {
                    color: "#6A6A6A",
                    font: {
                        family: "Roboto",
                        size: 14,
                        weight: "400",
                    },
                    callback: function (value) {
                        return value;
                    },
                    align: "start",
                    padding: 10,
                },
                grace: "5%",
                title: {
                    display: true,
                    color: "#B5B5B5",
                    text: "Y axis title",
                    align: "end",
                    font: {
                        family: "Roboto",
                        size: 14,
                        weight: "400",
                        lineHeight: "1.2",
                    },
                    padding: {
                        bottom: 0,
                    },
                },
                suggestedMax: 0.01,
            },
            x: {
                barThickness: 20,
                grid: {
                    display: false,
                },
                ticks: {
                    color: "#6A6A6A",
                    font: {
                        family: "Roboto",
                        size: 13,
                        weight: "400",
                        lineHeight: "130%",
                    },
                    maxRotation: 0,
                    padding: 20,
                },
            },
        },
        animations: {
            x: { duration: 0 },
            y: {
                from: (ctx) => {
                    const { max, min, top, bottom } = ctx.chart.scales.y;
                    return ((bottom - top) / (max - min)) * max + top;
                },
            },
            width: { duration: 0 },
        },
        plugins: {
            title: {
                display: false,
            },
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false,
                external: chartUtils.customTooltip({}),
            },
            mirrorEffect: {
                heightRatio: 0.5,
                maxHeight: 20,
            },
        },
    };

    const lineChartDatasetOptions = {
        borderColor: "#00BA29",
        backgroundColor: "#00BA29",
        pointRadius: 0.3,
        pointHitRadius: 4,
        pointHoverRadius: 4,
        fill: chartUtils.getLineGradient,
        borderJoinStyle: "round",
        borderWidth: 4,
    };

    const lineChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        stacked: false,
        interaction: { mode: "index", axis: "x", intersect: false },
        layout: {
            padding: {
                left: 40,
                right: 60,
                top: 30,
                bottom: 0,
            }
        },
        scales: {
            y: {
                display: true,
                position: "left",
                border: {
                    display: false,
                },
                ticks: {
                    color: "#6A6A6A",
                    font: {
                        family: "Roboto",
                        size: 14,
                        weight: "400",
                        lineHeight: "1.2",
                    },
                    callback: function (value) {
                        return value;
                    },
                    align: "start",
                    padding: 10,
                },
                title: {
                    display: true,
                    color: "#B5B5B5",
                    text: "Y axis title",
                    align: "end",
                    font: {
                        family: "Roboto",
                        size: 14,
                        weight: "400",
                        lineHeight: "1.2",
                    },
                    padding: {
                        bottom: 0,
                    },
                },
                grace: "5%",
                min: 0,
            },
            x: {
                barThickness: 20,
                grid: {
                    display: false,
                },
                ticks: {
                    color: "#6A6A6A",
                    font: {
                        family: "Roboto",
                        size: 13,
                        weight: "400",
                        lineHeight: "1.2",
                    },
                    maxRotation: 0,
                    padding: 20,
                },
                beforeFit: (scale) => {
                    scale.ticks = scale.ticks.map((el) => {
                        return el;
                    });
                },
            },
        },
        animations: {
            x: { duration: 0 },
            y: {
                from: (ctx) => {
                    const { max, min, top, bottom } = ctx.chart.scales.y;
                    return ((bottom - top) / (max - min)) * max + top;
                },
            },
        },
        plugins: {
            title: {
                display: false,
            },
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false,
                external: chartUtils.customTooltip({}),
            },
        },
    };

    const pieChartDatasetOptions = {
        backgroundColor: (data) => chartUtils.getChartColor(data.dataIndex),
        borderColor: "#ffffff",
    };

    const pieChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        stacked: false,
        layout: {
            padding: {
                right: 90,
                top: 40,
                left: 90,
                bottom: 40,
            },
        },
        animations: {
            outerRadius: { duration: 0 },
        },
        plugins: {
            title: {
                display: false,
            },
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false,
                external: chartUtils.customPieTooltip({}),
            },
            pieLabels: {
                fontSize: 14,
                lineOffsetHorizontal: 20,
            },
            pieLegend: {
                inside: true,
            }
        },
    };

    return { barChartDatasetOptions, barChartOptions, lineChartDatasetOptions, lineChartOptions, pieChartDatasetOptions, pieChartOptions };
});
